import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Thaprachan Thai</title>
        <meta name="description" content="The page you are looking for could not be found." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      
      <div className="min-h-screen bg-background bg-paper-texture flex items-center justify-center px-4">
        <div className="text-center max-w-xl">
          <motion.h1 
            className="font-heading text-5xl lg:text-6xl text-secondary mb-6"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            404
          </motion.h1>
          
          <motion.h2
            className="font-heading text-2xl md:text-3xl mb-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Page Not Found
          </motion.h2>
          
          <motion.p
            className="text-lg mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
          >
            The page you are looking for does not exist or has been moved.
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <Link 
              to="/"
              className="px-8 py-3 bg-primary text-white rounded-sm font-medium hover:bg-primary/90 transition-colors inline-block"
            >
              Return to Home
            </Link>
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default NotFound; 